module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"date":"Criada em {0}","copy":"Copiar URL","copied":"URL copiada!","sends":"Envios de SMS","inbound":"Retorno SMS","last":"Última mensagem enviada","empty":{"text":"Sala vazia. 👀","what":"Essa é a sala onde suas campanhas SMS aparecerão. Ela está vazia porque você ainda não criou uma campanha.","ask":"Deseja começar?","help":"A gente te ajuda.","create":"Criar minha primeira campanha"}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Campaign/Campaign.vue
// module id = 119
// module chunks = 0